module.exports = __webpack_public_path__ + "img/vegetable-mustard-greens-190x100.26c74cd4.jpg";